import { render, staticRenderFns } from "./ProfileItems.vue?vue&type=template&id=43d6b481"
import script from "./ProfileItems.vue?vue&type=script&lang=js"
export * from "./ProfileItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports